<template>
    <div class="color-vmain vmain">
        <div>
            <header-app />
        </div>
        <div>
            <router-view :key="$route.path" />
        </div>
        <div>
            <footer-app />
        </div>

    </div>
</template>

<script>
import HeaderApp from './components/header.vue'
import FooterApp from './components/footer_new.vue'
export default {
    components: {
        FooterApp,HeaderApp
    }
}
</script>